import EditIcon from '@mui/icons-material/Edit';
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useState, useEffect } from 'react';
import api from '../../services/api/axiosConfig';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { LocalizationProvider, DatePicker, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
interface PaymentColumn {
    id: 'date' | 'transactionId' | 'amount' | 'paymentMethod' | 'status' | 'action';
    label: string;
    minWidth?: number;
    align?: 'left';
    format?: (value: number) => string;
  }
  
  const paymentColumns: PaymentColumn[] = [
    { id: 'date', label: 'DATE', minWidth: 170 },
    { id: 'transactionId', label: 'TRANSACTION ID', minWidth: 100 },
    {
        id: 'amount',
        label: 'AMOUNT',
        minWidth: 170,
        align: 'left',
        // format: (value: number) => value.toLocaleString('en-US'),
      },
      {
        id: 'paymentMethod',
        label: 'PAYMENT METHOD',
        minWidth: 170,
        align: 'left',
        // format: (value: number) => value.toLocaleString('en-US'),
      },
      {
        id: 'status',
        label: 'STATUS',
        minWidth: 170,
        align: 'left',
        // format: (value: number) => value.toLocaleString('en-US'),
      },
    {
      id: 'action',
      label: 'ACTION',
      minWidth: 170,
      align: 'left',
      // format: (value: number) => value.toLocaleString('en-US'),
    },
    
  ];
  
  interface PaymentData {
    date: string;
    transactionId: string;
    amount: string;
    paymentMethod: string;
    status: string;
    action: any;
  }
  
  function paymentCreateData(
    date: string,
    transactionId: string,
    amount: string,
    paymentMethod: string,
    status: string,
    action: any,
  ): PaymentData {
    return { date, transactionId, amount, paymentMethod, status, action };
  }

  
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
    ...theme.applyStyles('dark', {
      backgroundColor: '#0DA85A',
    }),
  },
}));

const PaymentHistoryContent = () => {
  const [extendDialogOpen, setExtendDialogOpen] = useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [selectedExtension, setSelectedExtension] = useState<'4hours' | '8hours' | 'fullday' | null>(null);
  const [cancelReason, setCancelReason] = useState('');
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({
    open: false,
    message: '',
    severity: 'success'
  });
  
  const [value, setValue] = useState<Date | null>(new Date("2025-06-10"));
  const [calenderOpen, setCalenderOpen] = useState(false);
  const [checkOutValue, setCheckOutValue] = useState<Date | null>(new Date("2025-06-10"));
  const [checkOutCalenderOpen, setCheckOutCalenderOpen] = useState(false);
  const [time, setTime] = useState<Date | null>(new Date());  // Must be Date type
  const [openTime, setOpenTime] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [paymentHistory, setPaymentHistory] = useState<any[]>([]);
  const [totalPaymentHistory, setTotalPaymentHistory] = useState(0);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalAmount: 0,
    averageAmount: 0,
    totalTransactions: 0,
    completedTransactions: 0,
    pendingTransactions: 0,
    failedTransactions: 0,
    refundedTransactions: 0
  });

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatPaymentMethod = (paymentMethod: string, paymentDetails: any) => {
    if (paymentMethod === 'card' && paymentDetails?.card_last4) {
      const brand = paymentDetails?.card_brand || 'Card';
      const brandCapitalized = brand.charAt(0).toUpperCase() + brand.slice(1);
      return `${brandCapitalized}****${paymentDetails.card_last4}`;
    }
    return paymentMethod.charAt(0).toUpperCase() + paymentMethod.slice(1);
  };

  const paymentRows = paymentHistory.map((item: any) => {
    return paymentCreateData(
      formatDate(item.created_at),
      item.transaction_reference || item.id,
      `$${Number(item.amount).toFixed(2)}`,
      formatPaymentMethod(item.payment_method, item.payment_details),
      item.payment_status,
      <>
        <IconButton sx={{ backgroundColor: '#222D38', borderRadius: '0px', borderBottomLeftRadius: '5px', borderTopLeftRadius: '5px', marginRight: '2px' }}><VisibilityOutlinedIcon /></IconButton>
        <IconButton sx={{ backgroundColor: '#222D38', borderRadius: '0px', marginRight: '2px' }}><FileDownloadOutlinedIcon /></IconButton>
        <IconButton sx={{ backgroundColor: '#222D38', borderRadius: '0px', marginRight: '2px', borderBottomRightRadius: '5px', borderTopRightRadius: '5px'}}><DeleteOutlineOutlinedIcon /></IconButton>
      </>
    );
  });

  useEffect(() => {
    const fetchPaymentHistory = async () => {
      try {
        setLoading(true);
        const response = await api.get(
          `/payments/payments-transactions/history?page=${page + 1}&size=${rowsPerPage}&includeStats=true&sort=created_at,desc`
        );

        setPaymentHistory(response.data.data);
        setTotalPaymentHistory(response.data.totalItems);
        if (response.data.stats) {
          setStats(response.data.stats);
        }
      } catch (error) {
        console.error("Error fetching payment history:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentHistory();
  }, [page, rowsPerPage]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
    <Box sx={{ background: '#151A23', color: '#fff', marginTop: "64px", mb:"-80px", borderTop:"1px solid #2C353F", borderBottom:"1px solid #2C353F", padding: "17px 31px",
      "& svg":{
        fontSize: "24px",
        display: "block",
      }
     }}>
        <Typography sx={{ fontSize: 18, fontWeight: "semibold", color: "#fff", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        Payment History
        </Typography>
        </Box>
    <Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2, md: 3 }, background: '#151A23', minHeight: '100vh', color: '#fff', marginTop: 10 }}>
      {/* Header */}
      
      <Paper sx={{ boxShadow: 'none', mb: 3, background: '#131A21', borderRadius: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }} elevation={4}>
        <Box>
      <Typography variant="h6" fontWeight="bold" fontSize={30}>Payment History</Typography>
          {/* <Typography variant="h6" fontWeight="bold" >{booking?.botel?.name}</Typography> */}
          <Typography variant="caption" sx={{ color: "white", fontSize: 16 }}>Track your transactions, refunds, and manage your subscriptions</Typography>
        </Box>
      </Paper>

      {/* Booking Timeline */}
      <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3 }} elevation={4}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Typography fontWeight="bold" fontSize={24}>Booking Timeline</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button variant="contained" size="small" sx={{fontSize: 16, background: '#181F2A', color: 'white', fontWeight: 700, border:"1px solid white", borderRadius: 2, textTransform: 'none', px: 2, mr: 1, '&:hover': { background: '#232B3E' } }}>550 Points Until Gold</Button>
          </Box>
        </Box>
        <Box sx={{ width: '100%', mb: 3, mt: 3}}>
          <BorderLinearProgress variant="determinate" value={80} />
        </Box>
        <Grid container spacing={2}>
          <Grid size={{xs: 12, md:4}} sx={{ background: '#131A21', borderRadius: 2, p: 4, pb: 4}}>
            <Typography fontSize={16} >Total Spent <img
                  src="/icons/cards-icon.svg"
                  alt="calendar icon"
                  style={{ height: 22, float: 'right'}}
          /></Typography>
          <Typography fontSize={24} sx={{color:"white", fontWeight: 700, py: "10px"}}>
            ${stats.totalAmount ? stats.totalAmount.toFixed(2) : '0.00'}
          </Typography>
          <Typography fontSize={16} sx={{color:"#0DA85A"}}>
            {stats.totalTransactions} transaction{stats.totalTransactions !== 1 ? 's' : ''}
          </Typography>
          </Grid>
          <Grid size={{xs: 12, md:4}} sx={{ background: '#131A21', borderRadius: 2, p: 4, pb: 4}}>
            <Typography fontSize={16} >Pending Refunds
            <RefreshOutlinedIcon sx={{ color: 'white', fontSize: 27, float: 'right'}} />
          </Typography>
          <Typography fontSize={24} sx={{color:"white", fontWeight: 700, py: "10px"}}>
            ${stats.refundedTransactions > 0 ? (stats.refundedTransactions * stats.averageAmount).toFixed(2) : '0.00'}
          </Typography>
          <Typography fontSize={16}>
            {stats.refundedTransactions} refund{stats.refundedTransactions !== 1 ? 's' : ''} processing
          </Typography>
          </Grid>
          <Grid size={{xs: 12, md:4}} sx={{ background: '#131A21', borderRadius: 2, p: 4, pb: 4}}>
            <Typography fontSize={16} >Average Transaction <img
                  src="/icons/calender-icon.svg"
                  alt="calendar icon"
                  style={{ height: 22, float: 'right'}}
          /></Typography>
          <Typography fontSize={24} sx={{color:"white", fontWeight: 700, py: "10px"}}>
            ${stats.averageAmount ? stats.averageAmount.toFixed(2) : '0.00'}
          </Typography>
          <Typography fontSize={16}>
            {stats.completedTransactions} completed
          </Typography>
          </Grid>
        </Grid>
       
      </Paper>
    
      {/* Payment History */}
      <Grid container spacing={3}>
        <Grid size={{xs: 12, md: 12, lg: 12, xl: 12}} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Paper sx={{ mb: 3, borderRadius: 3, border:"1px solid #2C353F"}} elevation={4}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#283441' }}>
              <TableCell align="left" colSpan={6} sx={{ backgroundColor: '#283441', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', fontSize:"24px", fontWeight:"semibold" }}>
              Transaction History
              </TableCell>
            </TableRow>
            <TableRow >
              {paymentColumns.map((column, index) => (
                <TableCell
                  sx={{ fontSize:"16px", fontWeight:"medium", backgroundColor: '#192633', borderRight: index !== paymentColumns.length - 1 ? '1px solid #2C353F' : 'none', }}
                  key={column.id}
                  align={column.align}
                  style={{ top: 57, minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: '#131A21' }}>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                  <CircularProgress sx={{ color: '#3776FF' }} />
                </TableCell>
              </TableRow>
            ) : paymentRows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 6 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <Typography sx={{ color: '#b0b8c1', fontSize: 16, fontWeight: 500 }}>
                      No payment history found
                    </Typography>
                    <Typography sx={{ color: '#6A6E71', fontSize: 14 }}>
                      Your payment transactions will appear here
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              paymentRows.map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={`${row.transactionId}-${index}`}>
                    {paymentColumns.map((column) => {
                      const value = row[column.id as keyof PaymentData];
                      const isStatus = column.id === 'status';
                      const isAction = column.id === 'action';
                      
                      return (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          sx={{ fontSize: "14px", fontWeight: "medium", pl: "5px", "&:last-child": {
                            pl: 0,
                          } }}
                        >
                          {isAction ? (
                            value
                          ) : isStatus ? (
                            <Typography
                              sx={{
                                display: "inline-block",
                                px: 1.5,
                                py: 0.5,
                                borderRadius: "8px",
                                fontSize: "13px",
                                fontWeight: "bold",
                                textTransform: "capitalize",
                                backgroundColor:
                                  value === "pending" || value === "In Progress"
                                    ? "#965E05"
                                    : value === "completed" || value === "Completed"
                                    ? "#059669"
                                    : value === "failed"
                                    ? "#E23220"
                                    : value === "refunded"
                                    ? "#E23220"
                                    : "transparent",
                                color:
                                  value === "pending" || value === "In Progress"
                                    ? "#FFB135"
                                    : value === "completed" || value === "Completed"
                                    ? "#2CEFA7"
                                    : value === "failed"
                                    ? "#FFDFDB"
                                    : value === "refunded"
                                    ? "#FFAEA6"
                                    : "#fff",
                              }}
                            >
                              {value}
                            </Typography>
                          ) : (
                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: "medium",
                                color: "#fff",
                              }}
                            >
                              {column.format && typeof value === "number"
                                ? column.format(value)
                                : value}
                            </Typography>
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={totalPaymentHistory}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
        </Paper>
          </Grid>
        
     </Grid>

      {/* Refund Tracking */}
      <Grid container spacing={2} sx={{ p: 2, background: '#1F262C', borderRadius: 3 }}>
        <Grid size={{ xs: 12, md: 6 }}>
            <Typography fontWeight="bold" fontSize={24} sx={{ mb: 3 }}>Refund Tracking</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, backgroundColor: '#131A21', borderRadius: "20px", p: 4 }}>
            <Typography sx={{ color: '#983E1D',backgroundColor:"#F5B8A1", fontSize: 14, display:"inline",py:"4px", px:"10px", borderRadius:"8px", width:"fit-content", mb:"16px"}}>No Refunds</Typography>
            <Typography variant="body2" sx={{ color: 'white', mb:"16px", display:"flex", alignItems:"center"}}><CheckCircleIcon sx={{mr:"16px"}} /> Refund Requested</Typography>
            <Typography variant="body2" sx={{ color: 'white', mb:"16px", display:"flex", alignItems:"center"}}><CheckCircleIcon sx={{mr:"16px"}} /> Under Review</Typography>
            <Typography variant="body2" sx={{ color: 'white', mb:"16px", display:"flex", alignItems:"center"}}><CheckCircleIcon sx={{mr:"16px"}} /> Procession Refund</Typography>
            </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
            <Typography fontWeight="bold" fontSize={24} sx={{ mb: 3 }}>&nbsp;</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, backgroundColor: '#131A21', borderRadius: "20px", p: 4, pb: 5.2 }}>
            <Typography sx={{fontSize: 14, display:"inline",py:"4px", mb:"16px"}}>Refund Policy</Typography>
            <Typography variant="body2" sx={{ color: 'white', mb:"16px", display:"flex", alignItems:"center"}}>
                <img
                  src="/icons/info-blue-icon.svg"
                  alt="calendar icon"
                  style={{ height: 24, marginRight:"16px"}}
          /> 
          Refunds typically process within 3-5 business days
          </Typography>
            <Typography variant="body2" sx={{ color: 'white', mb:"16px", display:"flex", alignItems:"center"}}>
                <img
                  src="/icons/info-blue-icon.svg"
                  alt="calendar icon"
                  style={{ height: 24, marginRight:"16px"}}
          /> 
          Amount will be returned to original payment method
          </Typography>
            <Typography variant="body2" sx={{ color: 'white', mb:"16px", display:"flex", alignItems:"center"}}>
                <img
                  src="/icons/info-blue-icon.svg"
                  alt="calendar icon"
                  style={{ height: 24, marginRight:"16px"}}
          /> 
          Contact support for any questions about your refund
          </Typography>
            </Box>
        </Grid>
      </Grid>

      <Box sx={{ mt: "20px", mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', gap: 2, backgroundColor: '#003584', borderRadius: "12px", p: 2 }}>
         
         <Box>
          <Alert 
            icon={<RocketLaunchOutlinedIcon sx={{ fontSize: 68, color: 'white' , stroke: "#003584"}} />} 
            severity="info" 
            sx={{ background:  '#003584' , color: '#fff', borderRadius: "12px", alignItems: 'center', fontWeight: 500, p: 2, display: 'flex' }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 30 }}>
            Upgrade Your Botel Experience
               </Typography>
            <Typography sx={{ color: "white", fontWeight: 500, fontSize: 18 }}>
            Get access to premium features and boost your hosting revenue
              </Typography>
              
            
            </Box>
          </Alert>
          </Box>
          <Button variant="contained" color="primary" sx={{color:"#003584",backgroundColor:"#fff",  borderRadius: "10px",  fontSize: 16, fontWeight: 700, py: 1.5 , mr: 3}}>
          Explore Premium Features
          </Button>
        </Box>
    </Box>
    </>
  );
};

export default PaymentHistoryContent; 